/* =====================================================
   assets/real-results-testimonials-2026.js
   NuFace 2026 Redesign — Testimonial slider controller
   MS 2026-05-18 | KC 2026-06-22: mobile infinite-loop horizontal slider

   Desktop  : fade in-place (CSS opacity transition via is-active class)
   Mobile   : native scroll-snap flex track + seamless clone loop
              (mirrors pdp-key-ingredients-2026.js / find-device-fit-2026.js).
              Manual only — native swipe + arrows; no autoplay.
   ===================================================== */

(function () {
  'use strict';

  var MOBILE_BP = 1023; /* matches CSS ≤1023px block */
  var CARD_GAP = 8; /* px between cards — matches CSS gap on mobile track */
  var EAGER_NEIGHBORS = 1; /* slides each side of the visible one to load eagerly */

  function initSection(section) {
    var track = section.querySelector('[data-rr-track]');
    if (!track) return;

    var realSlides = Array.prototype.slice.call(
      track.querySelectorAll('[data-rr-slide]')
    );
    var n = realSlides.length;
    if (n < 2) return;
    if (section.dataset.rrInited === '3') return;
    section.dataset.rrInited = '3';

    var prevBtn = section.querySelector('[data-rr-prev]');
    var nextBtn = section.querySelector('[data-rr-next]');
    var nav = section.querySelector('.rr-testimonials-2026__nav');
    var current = 0;

    for (var i = 0; i < n; i++) {
      if (realSlides[i].classList.contains('is-active')) {
        current = i;
        break;
      }
    }

    /* Clones are aria-hidden but still contain links/CTAs — keep them out of tab order. */
    function removeFocusFromSubtree(root) {
      var focusables = root.querySelectorAll(
        'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      for (var i = 0; i < focusables.length; i++) {
        focusables[i].setAttribute('tabindex', '-1');
      }
    }

    function prepareClone(slide) {
      var clone = slide.cloneNode(true);
      clone.removeAttribute('data-rr-slide');
      clone.setAttribute('aria-hidden', 'true');
      clone.classList.remove('is-active', 'rr-current');
      clone.classList.add('rr-clone');
      removeFocusFromSubtree(clone);
      return clone;
    }

    var mobileClonesReady = false;

    function ensureMobileClones() {
      if (mobileClonesReady) return;
      mobileClonesReady = true;
      var beforeFrag = document.createDocumentFragment();
      var afterFrag = document.createDocumentFragment();
      realSlides.forEach(function (slide) {
        afterFrag.appendChild(prepareClone(slide));
        beforeFrag.appendChild(prepareClone(slide));
      });
      track.appendChild(afterFrag);
      track.insertBefore(beforeFrag, track.firstChild);
      /* Clones land in the DOM lazy; the window re-applies priority around
         wherever the track is actually sitting. */
      applyEagerWindow();
    }

    function teardownMobileClones() {
      if (!mobileClonesReady) return;
      var clones = track.querySelectorAll('.rr-clone');
      for (var i = 0; i < clones.length; i++) clones[i].remove();
      mobileClonesReady = false;
      track.scrollLeft = 0;
    }

    var mql = window.matchMedia('(max-width: ' + MOBILE_BP + 'px)');

    function allSlides() {
      return track.querySelectorAll('.rr-testimonials-2026__slide');
    }

    /* Only the visible slide and its immediate neighbours load eagerly, so a
       swipe still lands on a decoded image without every below-fold slide
       competing with the hero for bandwidth and priority. */
    function setSlidePriority(slide, eager) {
      var imgs = slide.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (eager) {
          img.loading = 'eager';
          img.setAttribute('fetchpriority', 'high');
          if (typeof img.decode === 'function') {
            img.decode().catch(function () {});
          }
        } else {
          img.loading = 'lazy';
          img.setAttribute('fetchpriority', 'auto');
        }
      }
    }

    function applyEagerWindow(centerIdx) {
      var list = allSlides();
      if (!list.length) return;
      if (typeof centerIdx !== 'number') {
        centerIdx = 0;
        for (var j = 0; j < list.length; j++) {
          if (list[j].classList.contains('rr-current') ||
              list[j].classList.contains('is-active')) {
            centerIdx = j;
            break;
          }
        }
      }
      for (var i = 0; i < list.length; i++) {
        setSlidePriority(list[i], Math.abs(i - centerIdx) <= EAGER_NEIGHBORS);
      }
    }

    applyEagerWindow();

    function step() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || CARD_GAP;
      return realSlides[0].getBoundingClientRect().width + gap;
    }

    function snapOffset() {
      return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
    }

    function setWidth() {
      return n * step();
    }

    function originalIndexFromScrollIdx(idx) {
      if (idx >= n && idx < 2 * n) return idx - n;
      if (idx < n) return idx;
      return idx - 2 * n;
    }

    function centerOriginals() {
      if (!mql.matches) return;
      ensureMobileClones();
      track.scrollLeft = setWidth() - snapOffset();
    }

    function normalize() {
      if (!mql.matches) return;
      var s = setWidth();
      var pad = snapOffset();
      if (track.scrollLeft >= 2 * s - pad - 1) track.scrollLeft -= s;
      else if (track.scrollLeft < s - pad - 1) track.scrollLeft += s;
    }

    function syncActive(origIdx) {
      current = origIdx;
      for (var i = 0; i < n; i++) {
        var active = i === origIdx;
        realSlides[i].classList.toggle('is-active', active);
        realSlides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      if (!mql.matches) applyEagerWindow();
    }

    function syncCurrentFromScroll() {
      if (!mql.matches) return;
      var list = allSlides();
      if (!list.length) return;
      var idx = Math.round((track.scrollLeft + snapOffset()) / step());
      idx = Math.max(0, Math.min(idx, list.length - 1));
      for (var i = 0; i < list.length; i++) {
        list[i].classList.toggle('rr-current', i === idx);
      }
      applyEagerWindow(idx);
      syncActive(originalIndexFromScrollIdx(idx));
      positionNav();
    }

    function positionNav() {
      if (!nav) return;
      if (!mql.matches) {
        nav.style.top = '';
        return;
      }
      var box =
        section.querySelector(
          '.rr-testimonials-2026__slide.rr-current .rr-testimonials-2026__media-box'
        ) || section.querySelector('.rr-testimonials-2026__slide.is-active .rr-testimonials-2026__media-box') ||
        section.querySelector('.rr-testimonials-2026__media-box');
      if (!box) return;
      var br = box.getBoundingClientRect();
      var sr = section.getBoundingClientRect();
      if (!br.height) return;
      nav.style.top = br.top - sr.top + br.height / 2 + 'px';
    }

    function goToSlideDesktop(index) {
      var nextIndex = (index + n) % n;
      if (nextIndex === current) return;
      syncActive(nextIndex);
    }

    function advance(dir) {
      if (mql.matches) ensureMobileClones();
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    function goNext() {
      if (mql.matches) advance(1);
      else goToSlideDesktop(current + 1);
    }

    function goPrev() {
      if (mql.matches) advance(-1);
      else goToSlideDesktop(current - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') goPrev();
      else if (e.key === 'ArrowRight') goNext();
    });

    var raf, settle;
    track.addEventListener('scroll', function () {
      if (!mql.matches) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncCurrentFromScroll);
      clearTimeout(settle);
      settle = setTimeout(normalize, 90);
    }, { passive: true });

    function resetDesktop() {
      track.scrollLeft = 0;
      var list = allSlides();
      for (var i = 0; i < list.length; i++) {
        var active = !list[i].classList.contains('rr-clone') &&
          realSlides.indexOf(list[i]) === current;
        list[i].classList.toggle('is-active', active);
        list[i].classList.remove('rr-current');
      }
      syncActive(current);
      positionNav();
    }

    function onMQ() {
      if (mql.matches) {
        ensureMobileClones();
        centerOriginals();
        syncCurrentFromScroll();
      } else {
        teardownMobileClones();
        resetDesktop();
      }
    }

    if (mql.addEventListener) mql.addEventListener('change', onMQ);
    else if (mql.addListener) mql.addListener(onMQ);

    window.addEventListener('resize', function () {
      if (mql.matches) {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(syncCurrentFromScroll);
      } else {
        positionNav();
      }
    });

    requestAnimationFrame(function () {
      if (mql.matches) {
        ensureMobileClones();
        centerOriginals();
        syncCurrentFromScroll();
      }
    });

    window.addEventListener('load', function () {
      if (mql.matches) {
        ensureMobileClones();
        centerOriginals();
        syncCurrentFromScroll();
      }
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.rr-testimonials-2026[data-slides-count]');
    for (var i = 0; i < sections.length; i++) {
      var count = parseInt(sections[i].dataset.slidesCount, 10) || 0;
      if (count > 1) initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
